import React, { Fragment, useState } from "react";

import { GalleryPreview, GalleryOverlay } from '@beacharound/beacharound-ui';
import { getPlaceholderImage } from "../../helpers/images/getPlaceholderImage";

export default function GalleryComponent({ gallery, name, cover }) {

    const [galleryState, setGalleryState] = useState();

    if(!cover) { return <Fragment></Fragment> }

    let fullGallery = [];

    if (cover) {
        fullGallery = [{ url: cover || getPlaceholderImage('hotels')}]
    }

    if (gallery) {
        fullGallery = [
            ...fullGallery,
            ...(gallery?.sort((a, b) => a.index - b.index) || [])
        ].map((image, index) => {
            return {
                ...image,
                index
            }
        })
    }


    return (

        <Fragment>
            <GalleryPreview
                images={fullGallery}
                alt={name}
                openGallery={setGalleryState}
            />

            <GalleryOverlay
                images={fullGallery}
                alt={name}
                visible={galleryState}
                setVisible={() => setGalleryState(undefined)}
            />
        </Fragment>
    )
}
